import type { CoursePlanItem } from "../auth/api-client";

function findAnchorIndex(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): number | null {
  if (insertAfterPlanItemId === null) return null;
  if (insertAfterPlanItemId === undefined) {
    return planItems.length > 0 ? planItems.length - 1 : null;
  }
  let idx = planItems.findIndex((p) => p.planItemId === insertAfterPlanItemId);
  if (idx < 0) {
    idx = planItems.findIndex((p) => p.itemKind === "lesson" && p.lesson.id === insertAfterPlanItemId);
  }
  return idx >= 0 ? idx : null;
}

/** Lesson this presentation introduces (first lesson at or after the insert slot). */
export function followingLessonTitle(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string | null {
  const anchorIndex = findAnchorIndex(planItems, insertAfterPlanItemId);
  const start = anchorIndex === null ? 0 : anchorIndex + 1;
  for (let i = start; i < planItems.length; i++) {
    const item = planItems[i];
    if (item?.itemKind === "lesson") return item.lesson.title;
  }
  return null;
}

export function defaultPresentationTitle(
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string {
  const lesson = followingLessonTitle(planItems, insertAfterPlanItemId);
  if (lesson) return `Intro: ${lesson}`;
  return "New presentation";
}

export function resolvePresentationTitle(
  customTitle: string,
  planItems: readonly CoursePlanItem[],
  insertAfterPlanItemId: string | null | undefined
): string {
  const trimmed = customTitle.trim();
  if (trimmed) return trimmed;
  return defaultPresentationTitle(planItems, insertAfterPlanItemId);
}
